import React from 'react';
import PropTypes from 'prop-types';
import AccountsCreateForm from './AccountsCreateForm';
import AccountsOwnerForm from './AccountsOwnerForm';
import AccountsSearchUserForm from './AccountsSearchUserForm';
import AccountsSelectUserForm from './AccountsSelectUserForm';
import apiClient from 'clients/apiClient';
import compose from 'recompose/compose';
import config from 'helpers/config';
import styled from 'styled-components';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { createAccount } from 'store/actions/accounts/createAccounts';
import { Card, CardText } from 'material-ui';

const StyledCard = styled(Card)`
    margin-bottom: 30px;

    > div {
        padding-bottom: 0 !important;
    }
`;

class AccountsCreateWrapper extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            available_users: null,
            user: null,
        };
    }

    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
        } = this.props;

        const query = utils.filterEmptyValues(values);

        return new Promise((resolve) => {
            dispatchForm({
                onError: () => {
                    resolve();
                },
                onSuccess: (response) => {
                    const {
                        id,
                    } = response;

                    resolve(history.push(`/accounts/${ id }/show`));
                },
                values: query,
            });
        });
    }

    handleSearchUserForm = (values) => {
        const payload = {
            size: 96, // Maximum default pagination size incase more results can be returned.
        };

        utils.each(values, (value, key) => {
            if (utils.isString(value)) {
                payload[key] = `*${ value }*`;
            } else {
                payload[key] = value;
            }
        });

        return apiClient.read(`${ config.getApiBaseUrl() }/users`, payload)
            .then((response) => {
                return this.setState({
                    available_users: response.results,
                });
            });
    }

    handleResetUser = () => {
        this.setState({
            user: null,
        });
    }

    handleSelectUser = (user) => {
        this.setState({
            user: user,
        });
    }

    render() {
        const {
            available_users,
            user,
        } = this.state;

        const hasUserSelected = user !== null;
        const hasUsersResult = available_users !== null;

        if (hasUserSelected) {
            return (
                <div>
                    <StyledCard>
                        <CardText>
                            <AccountsOwnerForm
                                handleResetUser={ this.handleResetUser }
                                user={ user }
                            />
                        </CardText>
                    </StyledCard>
                    <Card>
                        <CardText>
                            <AccountsCreateForm
                                { ...this.props }
                                form='accounts_create'
                                handleSubmitForm={ this.handleSubmitForm }
                                user={ user }
                            />
                        </CardText>
                    </Card>
                </div>
            );
        }

        return (
            <div>
                <StyledCard>
                    <CardText>
                        <AccountsSearchUserForm
                            { ...this.props }
                            form='accounts_user_search'
                            handleSubmitForm={ this.handleSearchUserForm }
                        />
                    </CardText>
                </StyledCard>
                {hasUsersResult &&
                    <AccountsSelectUserForm
                        { ...this.props }
                        available_users={ available_users }
                        onSubmit={ this.handleSelectUser }
                    />
                }
            </div>
        );
    }
}

AccountsCreateWrapper.propTypes = {
    dispatchForm: PropTypes.func.isRequired,
    dispatchSearchUserForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    user: PropTypes.object,
};

const mapStateToProps = (state) => {
    return {
        loading: state.accounts.loading,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (payload) => {
            dispatch(createAccount(payload));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
);

export default enhance(AccountsCreateWrapper);



// WEBPACK FOOTER //
// ./src/pages/accounts/create/AccountsCreateWrapper.js